@use "~theme/typographyV2" as typography;
@use "~theme/breakpoints";

.card {
  padding: 28px;
  margin: 0;
  max-width: unset;
  border-radius: 20px;
}

.headerContainer {
  position: relative;
}

.header {
  color: var(--brand-indigo);
  display: flex;
  font-size: 28px;
  justify-content: space-between;
  align-items: baseline;
  font-family: typography.$font-serif;
  font-weight: 400;
  font-style: normal;
  line-height: 140%;
  letter-spacing: 0%;
  vertical-align: middle;
  @include breakpoints.desktop {
    font-size: 32px;    
  }
}

.ratio {
  white-space: nowrap;
  font-family: typography.$font-mont;
  font-weight: 700;
  font-size: 16px;
  line-height: 140%;
  letter-spacing: 0%;
  vertical-align: middle;
  color: rgba(0, 51, 102, 1);
}

.headerBubble {
  position: absolute;
  bottom: 12px;
  right: -16px;
}

.progressBar {
  margin-top: 12px;
  margin-bottom: 30px;
}

.section {
  padding-top: 10px;
}

.list {
  list-style: none;
  margin: 0;
  padding: 0;
}

.task {

  &:last-child {
    margin-bottom: unset;
  }
}

.taskTitle {
  display: flex;
  align-items: flex-start;
  color: var(--pure-black);
  font-family: typography.$font-mont;
  font-weight: 700;
  font-style: Regular;
  font-size: 16px;
  line-height: 200%;
  letter-spacing: 0%;
  vertical-align: middle;


  > img {
    margin-right: 6px;
    width: 20px;
    visibility: hidden;
  }
}

.taskTitleCompleted {
  color: var(--pure-black);
  font-family: typography.$font-mont;
  font-weight: 700;
  font-style: Bold;
  font-size: 16px;
  line-height: 200%;
  letter-spacing: 0%;
  vertical-align: middle;

  > img {
    visibility: visible;
  }
}

.taskDescription {
  color: var(--pure-black);
  font-family: typography.$font-mont;
  font-weight: 400;
  font-style: normal;
  font-size: 12px;
  line-height: 200%;
  letter-spacing: 0%;
  vertical-align: middle;
  padding-left: 26px; // to account for space given to checkmark in the title

  @include breakpoints.desktop {
    font-size: 16px;
  }
}